import React from 'react';
import Group from '@bubble-ui/primitive-group';
import Shape from '@bubble-ui/primitive-shape';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';

var FlagFI = function FlagFI() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Group, {
    id: "finland"
  }, /*#__PURE__*/React.createElement(Shape, {
    id: "white",
    fill: "#FFF",
    d: "M0,90a90,90 0 1,0 180,0a90,90 0 1,0 -180,0"
  }), /*#__PURE__*/React.createElement(Shape, {
    d: "M60,5.12116698 L60,74.999167 L178.755624,75 C179.515561,79.5296895 179.937143,84.1741114 179.993492,88.9063887 L180,90 C180,94.7456344 179.632699,99.4054811 178.924976,103.952663 L178.755624,105 L59.999,104.999167 L60,174.878829 C49.108036,171.029072 39.1783844,165.142166 30.6688469,157.675911 L30,157.083197 L30,104.999167 L1.24437643,105 C0.484438635,100.470311 0.0628566599,95.8258886 0.00650789715,91.0936113 L0,90 C0,85.2543656 0.367300704,80.594519 1.07502472,76.0473374 L1.24437643,75 L30,74.999167 L30,22.916803 C38.4344776,15.3677414 48.3011167,9.38598068 59.1421153,5.42932288 L60,5.12116698 Z",
    id: "blue",
    fill: "#227FBB"
  })));
};

FlagFI.displayName = 'FlagFI';
export default withFlagWrapper(FlagFI);
//# sourceMappingURL=index.js.map